import { Icon } from "@iconify/react";
import React, { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { FaTrash } from "react-icons/fa";
import { FaXmark } from "react-icons/fa6";


const SkuDiamondAccordian = ({
  style,
  setNewSku,
  newSku,
  clientCode,
  diamondShapes,
  diamondClarities,
  diamondColors,
  diamondCuts,
  settingTypes,
}) => {
  const defaultvalue = {
    DiamondName: "",
    DiamondShape: "",
    DiamondClarity: "",
    DiamondColour: "",
    DiamondSize: 0,
    Sleve: "",
    DiamondWeight: 0,
    DiamondRate: 0,
    DiamondPieces: 0,
    DiamondAmount: 0,
    DiamondCut: "",
    SettingType: "",
    Certificate: "",
    Description: "",
    TotalDiamondWeight: 0,
    // DiamondPurchaseAmt: "0",
    ClientCode: clientCode,
  };
 
  const { register, handleSubmit, watch, control,reset } = useForm({
    defaultValues: {
      diamonds: [...newSku.Diamonds,defaultvalue],
    },
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "diamonds", // Name of the array field
  });
const [isOpen, setIsOpen] = useState(false);
  const formValues = watch();

  console.log(formValues?.diamonds);
  console.log(fields);
useEffect(() => {
    // Only reset if newSku.Diamonds has changed
    if (JSON.stringify(newSku?.Diamonds) !== JSON.stringify(formValues?.diamonds)) {
      reset({
        diamonds: [...newSku.Diamonds],
      });
    }
  }, [newSku, reset]);

  useEffect(() => {
    // const handler = setTimeout(() => {
      setNewSku((prev) => ({
        ...prev,
        Diamonds: formValues?.diamonds,
      }));
    // }, 1000); // Debounce save for 1 second
  
    // return () => clearTimeout(handler);
  }, [formValues?.diamonds]);


    useEffect(() => {
      // Ensure at least one form is always present when opened
      if (isOpen && fields.length === 0) {
        append(defaultvalue);
      }
    }, [isOpen]);
    
    
  return (
    <div
      style={{
        width: "100%",
        marginBottom: "10px",
      }}
      className={style.dropdown}
    >
      <div
        onClick={() => setIsOpen(!isOpen)}
        // className={style.dropdownButton}
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "10px 20px",
          background: "#627282",
        }}
      >
        <p style={{ color: "#000", margin: 0, color: "white" }}>Diamond</p>
        <Icon
          // icon={isOpen ? chevronUp : chevronDown}
          icon={isOpen ? "bx:up-arrow" : "bx:down-arrow"}
          className={style.icon}
          style={{ color: "#fff", cursor: "pointer" }}
        />
      </div>
      {isOpen && (
        <div className={style.dropdownContent}>
          {fields?.map((diamond, index) => (
            <DiamondForm
              diamond={diamond}
              remove={remove}
              index={index}
              style={style}
              register={register}
              newSku={newSku}
              diamondShapes={diamondShapes}
              diamondClarities={diamondClarities}
              diamondColors={diamondColors}
              diamondCuts={diamondCuts}
              settingTypes={settingTypes}
              append={append}
              defaultValue={defaultvalue}
            />
          ))}

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: "10px",
              marginTop: "10px",
            }}
          >
            {/* <button
              onClick={() => append(defaultvalue)}
              type="button"
              className={style["custom-btn"]}
            >
              <Icon icon="line-md:plus" width="24" height="24" />
              Add
            </button> */}

          
          </div>
        </div>
      )}
    </div>
  );
};

export default SkuDiamondAccordian;

function DiamondForm({
  diamond,
  remove,
  index,
  style,
  register,
  newSku,
  diamondShapes,
  diamondClarities,
  diamondColors,
  diamondCuts,
  settingTypes,
  append,
  defaultvalue
}) {
  return (
    <div
      className={style.adminCategoryAddCategoryInnerBox}
      style={{ width: "100%" }}
    >
      <div className="adminSkuAddSkuInnerItemsStoneBox">
        <div
          className="adminSkuAddSkuInnerItemsStoneInnerBox"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(6, 1fr)",
            // gridTemplateColumns: {
            //   // xs: 'repeat(2, 1fr)',
            //   xs: "repeat(4, 1fr)",
            //   lg: "repeat(7, 1fr)",
            // },
            // gap: "20px",
            padding: "0",
            boxShadow: "none",
            alignItems: "center",
            justifyItems: "center",
            marginTop: "10px",
          }}
        >
          <div style={{ width: "90%" }} className="adminSkuAddSkuInnerItemsBox">
            <label>Diamond Name</label>
            <input
              type="text"
              //   value={diamond.DiamondName}
              style={{ width: "100%" }}
              placeholder={`Diamond Name ${index + 1}`}
              className={style["addCategory-input"]}
              {...register(`diamonds.${index}.DiamondName`)}
              //   onChange={(e) =>
              //     updateDiamond(
              //       index,
              //       "DiamondName",
              //       e.target.value
              //     )
              //   }
              list="diamondsList"
            />
          </div>
          <div style={{ width: "90%" }} className="adminSkuAddSkuInnerItemsBox">
            <label>Diamond Shape</label>
            <select
              name="DiamondShape"
              style={{ width: "100%" }}
              {...register(`diamonds.${index}.DiamondShape`)}
             
            >
              <option value={""}>Select Diamond Shape</option>
              {diamondShapes?.map((shape) => (
                <option key={shape.Id} value={shape.Id}>
                  {shape.DiamondValue}
                </option>
              ))}
            </select>
          </div>
          <div style={{ width: "90%" }} className="adminSkuAddSkuInnerItemsBox">
            <label>Diamond Clarity</label>
            <select
              name="DiamondClarity"
              style={{ width: "100%" }}
              {...register(`diamonds.${index}.DiamondClarity`)}
              
            >
              <option value={""}>Select Diamond Clarity</option>
              {diamondClarities?.map((item) => (
                <option key={item.Id} value={item.Id}>
                  {item.DiamondValue}
                </option>
              ))}
            </select>
          </div>
          <div style={{ width: "90%" }} className="adminSkuAddSkuInnerItemsBox">
            <label>Diamond Colour</label>
            <select
              name="DiamondColour"
              style={{ width: "100%" }}
              {...register(`diamonds.${index}.DiamondColour`)}
            >
              <option value={""}>Select Diamond Colour</option>
              {diamondColors?.map((item) => (
                <option key={item.Id} value={item.Id}>
                  {item.DiamondValue}
                </option>
              ))}
            </select>
          </div>
          <div style={{ width: "90%" }} className="adminSkuAddSkuInnerItemsBox">
            <label>Diamond Size</label>
            <input
              type="text"
              style={{ width: "100%" }}
              placeholder={`Diamond Size ${index + 1}`}
              className={style["addCategory-input"]}
              {...register(`diamonds.${index}.DiamondSize`)}
            />
          </div>
          <div style={{ width: "90%" }} className="adminSkuAddSkuInnerItemsBox">
            <label>Sleve</label>
            <input
              type="text"
              style={{ width: "100%" }}
              placeholder={`Sleve ${index + 1}`}
              {...register(`diamonds.${index}.Sleve`)}
              className={style["addCategory-input"]}
            />
          </div>
          <div style={{ width: "90%" }} className="adminSkuAddSkuInnerItemsBox">
            <label>Diamond Weight</label>
            <input
              type="number"
              className={style["addCategory-input"]}
              style={{ width: "100%" }}
              placeholder={`Diamond Weight ${index + 1}`}
              {...register(`diamonds.${index}.DiamondWeight`)}
            />
          </div>
          <div style={{ width: "90%" }} className="adminSkuAddSkuInnerItemsBox">
            <label>Diamond Rate</label>
            <input
              type="number"
              className={style["addCategory-input"]}
              style={{ width: "100%" }}
              placeholder={`Diamond Rate ${index + 1}`}
              {...register(`diamonds.${index}.DiamondRate`)}
            />
          </div>
          <div style={{ width: "90%" }} className="adminSkuAddSkuInnerItemsBox">
            <label>Diamond Pieces</label>
            <input
              type="text"
              className={style["addCategory-input"]}
              style={{ width: "100%" }}
              placeholder={`Diamond Pieces ${index + 1}`}
              {...register(`diamonds.${index}.DiamondPieces`)}

            />
          </div>
          <div style={{ width: "90%" }} className="adminSkuAddSkuInnerItemsBox">
            <label>Diamond Amount</label>
            <input
              type="text"
              className={style["addCategory-input"]}
              style={{ width: "100%" }}
              placeholder={`Diamond Amount ${index + 1}`}
              {...register(`diamonds.${index}.DiamondAmount`)}

            />
          </div>

          <div style={{ width: "90%" }} className="adminSkuAddSkuInnerItemsBox">
            <label>Diamond Cut</label>
            <select
              name="DiamondCut"
              style={{ width: "100%" }}
              {...register(`diamonds.${index}.DiamondCut`)}
            >
              <option value={""}>Select Diamond Cut</option>
              {diamondCuts?.map((item) => (
                <option key={item.Id} value={item.Id}>
                  {item.DiamondValue}
                </option>
              ))}
            </select>
          </div>
          <div style={{ width: "90%" }} className="adminSkuAddSkuInnerItemsBox">
            <label>Setting Type</label>
            <select
              name="SettingType"
              style={{ width: "100%" }}
              {...register(`diamonds.${index}.SettingType`)}
            >
              <option value={""}>Select Setting Type</option>
              {settingTypes?.map((item) => (
                <option key={item.Id} value={item.Id}>
                  {item.DiamondValue}
                </option>
              ))}
            </select>
          </div>
          <div style={{ width: "90%" }} className="adminSkuAddSkuInnerItemsBox">
            <label>Certificate</label>
            <input
              className={style["addCategory-input"]}
              type="text"
              style={{ width: "100%" }}
              placeholder={`Certificate Name ${index + 1}`}
              {...register(`diamonds.${index}.Certificate`)}
            />
          </div>
          <div style={{ width: "90%" }} className="adminSkuAddSkuInnerItemsBox">
            <label>Description</label>
            <input
              className={style["addCategory-input"]}
              type="text"
              style={{ width: "100%" }}
              placeholder={`Description ${index + 1}`}
              {...register(`diamonds.${index}.Description`)}
            />
          </div>

          {/* {stones.length > 1 && ( */}
          <div
            style={{
              display: 'flex',
              gap: '10px',
              alignItems: 'center',
              marginTop: '26px'
            }}
            className="adminSkuAddSkuInnerItemsBox"
          >
            <FaTrash
              size={28}
              style={{ cursor: "pointer", color: "#38414a" }}
              //  onClick={() => deleteStone(index)}
              onClick={() => remove(index)}
            />
             <Icon
              style={{ color: "#0077d4", cursor: "pointer" }}
              onClick={() => append(defaultvalue)}
              icon="ph:plus-fill"
              width="35"
              height="35"
            />
          </div>

        


          {/* )} */}
        </div>
      </div>
    </div>
  );
}
